import React, {useRef} from 'react';
import Pagination from "react-js-pagination";

//state
import {useRecoilState} from "recoil";
import wordsAtom from "../../core/atoms/wordsAtom";
import docsAtom from "../../core/atoms/docsAtom";
import showResetAtom from "../../core/atoms/showResetArom";

//components
import SingleDoc from "./SingleDoc";

//utils
import paginate from "../../core/utils/paginate";
import { forEach } from 'lodash';

const normalizeDelimitedIds = (value: any, delimiter: string) => {
    if (value === null || typeof value === 'undefined') return [];
    const str = String(value).trim();
    if (!str || str === '0') return [];
    return str
        .split(delimiter)
        .map((item) => String(item).trim())
        .filter((item) => item !== '' && item !== '0');
};

const normalizeTopics = (value: any) => {
    if (value === null || typeof value === 'undefined') return [];
    const raw = String(value).trim();
    if (!raw || raw === '0') return [];
    if (raw.startsWith('^') && raw.endsWith('^') && raw.length > 1) {
        return normalizeDelimitedIds(raw.slice(1, -1), '^');
    }
    return normalizeDelimitedIds(raw, '^');
};

const Documents = () => {

    const limit = 20;

    const tRef = useRef();

    React.useEffect(() => {
        const vizElement = document.querySelector('#viz');
        if(vizElement) {
            const onVizClick = () => {
                if (tRef && tRef.current && tRef.current.value) {
                    if(!init && tRef.current.value !== '0') setInit(true)
                    setTopic(+tRef.current.value)
                }
            };
            vizElement.addEventListener('click', onVizClick);
            return () => {
                vizElement.removeEventListener('click', onVizClick);
            }
        }
    },[])
    const [words] = useRecoilState<any>(wordsAtom);
    const [docs] = useRecoilState<any>(docsAtom);

    // const publicationDates = Object.keys(docs?.docs?.list || {})
    //     .map((key) => {
    //         return docs?.docs?.list[key].doc_publication_date;
    //     })
    //     .filter( v => v)
    //     .sort((a, b) => { return new Date(b).getTime() - new Date(a).getTime();
    //     });

    // loop list to return a dictionary key:value (doc_id: doc_publication_date)
    const pubDatesDict: {[key: string]: string} = {};
    Object.keys(docs?.docs?.list || {}).forEach((key) => {
        const doc = docs.docs.list[key];
        pubDatesDict[doc.doc_id] = doc.doc_publication_date;
    });

    const publicationDates = Object.values(pubDatesDict).filter( (v, i, a) => v && a.indexOf(v) === i );


    // console.log('>>pubDatesDict', pubDatesDict);
    // console.log('>>pubDatesDictxxx', Object.values(pubDatesDict).filter( (v, i, a) => v && a.indexOf(v) === i ));

    const [init, setInit] = React.useState(false);
    const [showReset, setShowReset] = useRecoilState(showResetAtom);

    const [coms, setComs] = React.useState<any>([])
    const [page, setPage] = React.useState<number>(1)

    const [body, setBody] = React.useState(0);
    const [topic, setTopic] = React.useState(0);
    const [publicationDate, setPublicationDate] = React.useState<string | null>(null);

    React.useEffect(() => {
        setShowReset(+topic > 0 || +body > 0 || publicationDate != null)
    },[topic, body, publicationDate])


    React.useEffect(() => {
        if(docs.recommendations && docs.recommendations.list) {
            setPage(1);
            setComs(getComs)
        }
    },[docs, body, topic, publicationDate])

    const getComs = () => {
        let list = Object.entries(docs.recommendations.list).map((rd:any) => {
            const d = rd[1];
            return {
                num: +d.part_id,
                doc: +d.doc_id,
                recommendation: d.part_text,
                body: +d.body_id,
                theme: normalizeTopics(d.part_topics),
                followUp: { color: d.part_follow, text: d.part_follow_text },
                country: normalizeDelimitedIds(d.part_countries, ','),
                status: d.part_approved,
                comment: d.part_comment,
                link: d.part_links
            }
        });
        if(body){
            list = list.filter(item => {
                return item.body === body
            })
        }
        if(topic){
            list = list.filter(item => {
                return item.theme.includes(String(topic))
            })
        }
        if(publicationDate){
            let foundDocIds:number[] = [];
            forEach(pubDatesDict, (value, key) => {
                if(value === publicationDate){
                    foundDocIds.push(+key);
                }
            });

            list = list.filter(item => {
                return foundDocIds.includes(item.doc)
            });

        }
        return list;
    }

    const bodyChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        if(!init) setInit(true)
        setBody(+e.target.value)
    }
    const topicChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        if(!init) setInit(true)
        setTopic(+e.target.value)
    }
    const publicationDateChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        if(!init) setInit(true)
        setPublicationDate(e.target.value === '0' ? null : e.target.value);
    }

    const changePage = (page:number) => {
        setPage(page);
        // @ts-ignore
        document.getElementById("filters").scrollIntoView({
            behavior: 'smooth'
        });
    }

    if(typeof words.site === 'undefined') {
        return <div>Loading...</div>
    }

    const interActions = () => {
        if(window.$setListInteractions && coms.length > 0) setTimeout(window.$setListInteractions, 100)
    }

    const sortByTopicName = (jsonArray: any) => {

        jsonArray.sort((a: any, b: any) => {
          const topicNameA = a[1].topic_name.toLowerCase();
          const topicNameB = b[1].topic_name.toLowerCase();
          if (topicNameA < topicNameB) {
            return -1;
          }
          if (topicNameA > topicNameB) {
            return 1;
          }
          return 0;
        });
    
        return jsonArray;
      };

    interActions();

    // @ts-ignore
    return (
        <React.StrictMode>
            <div id="filters">

                <div className="wrapper flexbox center">

                    <div id={'filter-notes'}>
                        <p className="note">
                            {words.site.starttext}
                        </p>
                        <div id="reset-filters" className={showReset ? '' : 'hidden'} onClick={() => setShowReset(false)}>
                            {words.site.reset}
                        </div>
                    </div>

                    <div id="filter-boxes">

                        <div className="filter-box" id="fbody">
                            <h4>
                                {words.site.mechanisms}
                            </h4>
                            <select className="form-control" id="body_id"
                                    onChange={bodyChange}
                                    name={'body'}>
                                <option value="0">
                                    {words.site.allmechamisms}
                                </option>
                                {
                                    docs && docs.bodies && docs.bodies.list ?
                                        Object.entries(docs.bodies.list).map((item:any) => {
                                            const doc = item[1];
                                            // check if name start with an extra dash like this: "- CAT"
                                            const bodyNameStripped = doc.body_name.startsWith('- ') ? doc.body_name.substring(2) : doc.body_name;
                                            return <option value={doc.body_id} key={'body'+doc.body_id}>
                                                {bodyNameStripped}
                                            </option>
                                        }) : null
                                }
                            </select>
                        </div>

                        <div className="filter-box" id="ftheme">
                            <h4>
                                {words.site.themes}
                            </h4>
                            <select className="form-control" id="topic_id" ref={tRef}
                                    onChange={topicChange}
                                    name={'topic'}>
                                <option value="0">
                                    {words.site.allthemes}
                                </option>
                                {
                                    docs && docs.topics && docs.topics.list ?
                                        sortByTopicName(Object.entries(docs.topics.list)).map((item:any) => {
                                            const topic = item[1];
                                            return <option value={topic.topic_id} key={'topic'+topic.topic_id}>
                                                {topic.topic_name}
                                            </option>
                                        }) : null
                                }
                            </select>
                        </div>

                        {/* publication date */}
                        <div className="filter-box" id="fpublicationdate">
                            <h4>
                                Publication dates
                            </h4>
                            <select className="form-control" id="publication_date_id"
                                    onChange={publicationDateChange}
                                    name={'publication_date'}>
                                <option value="0">
                                    {words.site.allPublicationDates || 'All publication dates'}
                                </option>
                                {
                                    publicationDates.map((dateValue, key) => {
                                        return <option value={dateValue} key={'publication_date'+key}>
                                            {dateValue}
                                        </option>
                                    })
                                }
                            </select>
                        </div>

                    </div>

                </div>

            </div>


            <div className="section_results center">
                <div className="container" id="parts">
                    {
                        !init ?
                            <div id="intro-message">
                                {words.site.select}
                            </div> :
                                coms.length > 0
                                    ? paginate(coms.map((item:any) => {
                                        return <SingleDoc com={item} key={'part_'+item.num}/>
                                    }),limit,page) : null
                    }
                    {
                        coms.length > limit && init
                        ?<Pagination
                                activePage={page}
                                itemsCountPerPage={limit}
                                totalItemsCount={coms.length}
                                pageRangeDisplayed={5}
                                onChange={changePage}
                                innerClass="pagination"
                                itemClass=""
                                activeClass="active"
                                linkClass=""
                            />: null
                    }
                </div>
                <div id="paginator"></div>
            </div>

            <div id="pop-up" className="hidden">
                <div className="cover">
                    <div className="wrapper"></div>
                    <div id="pu-window" style={{display: "block", left: "388.5px", top: "299.5px"}}>
                        <header>
                            <h2>Colors legend</h2>
                            <svg className="pu-close" width="17" height="17">
                                <line x1="1" x2="15" y1="1" y2="15"></line>
                                <line x1="15" x2="1" y1="1" y2="15"></line>
                            </svg>
                        </header>
                        <div className="pu-content">
                        </div>
                    </div>
                </div>
            </div>
        </React.StrictMode>
    )

}

export default Documents;